import React from 'react'
import "../../css/buttons/DegradeButton.css";
import { IoChevronForward } from "react-icons/io5";

const DegradeButton = ({ url = "/#", name, width, paddingLeft = 20, link }) => {
    
    const handleLink = (e) => {
        e.preventDefault();
        const target = e.target.getAttribute("href");
        const location = document.querySelector(target).offsetTop;
        window.scrollTo({
            left: 0,
            top: location - 80,
        });
    };

    return link ? (
        <a
            href="#entrenamientos"
            className="DegradeButton"
            onClick={handleLink}
            style={{ width: width, paddingLeft: paddingLeft }}
        >
            {name}
            <span className="create-account">
                <IoChevronForward />
            </span>
        </a>
    ) : (
        <a
            href={url}
            className="DegradeButton"
            style={{ width: width, paddingLeft: paddingLeft }}
        >
            {name}
            <span className="create-account">
                <IoChevronForward />
            </span>
        </a>
    );
}

export default DegradeButton;
